import { RaisedButton } from 'material-ui';
import moment from 'moment';
import React from 'react';

import { deleteRequestTC } from 'actions/tc/requests';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import OpenMailBlock from 'components/Base/Mails/OpenMailBlock';
import { execute } from 'store/configureStore';
import { saveRequestsDataDeleted } from 'sagas/orders';

class TcRequestsItem extends React.PureComponent {
    saveRequestsDataDeleted = async () => {
        try {
            await execute(saveRequestsDataDeleted, 'tc', { mailId: this.props.item.mailId });
        } catch (error) {
            console.error(error);
        }
    };

    deleteCargoRequest = () => {
        this.props.item.mailId && this.saveRequestsDataDeleted();
        this.props.deleteRequestTC(this.props.item._id);
    }

    render() {
        const { item } = this.props;

        let managementBlock = (
            <div className='paper-block'>
                <div className='name-block absolute small-name'>Managment</div>
                <RaisedButton
                    onClick={this.deleteCargoRequest}
                    label='Delete'
                    style={{ margin: '0 10px 0 0' }}
                    secondary
                />
            </div>
        );

        if (this.props.item.deleteBy) {
            managementBlock = (<div className='paper-block'>
                <div className='name-block absolute small-name'>Deleted</div>
                <span>Delete at: </span>{moment(item.deleteAt).format('MM-DD-YYYY')}<br />
                <span>Delete by: </span>{item.deleteBy.email}
            </div>);
        }

        return (
            <div className='paper-block item-request'>
                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>unique info</div>
                        <span>refNo: </span>{item.refNo}
                    </div>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>Delivery</div>
                        <span>Delivery port: </span>{item.deliveryPlaces[0].port ? item.deliveryPlaces[0].port.name : ''}<br />
                        <span>Readiness Date: </span>{moment(item.readinessDate).startOf('day').toDate().toLocaleDateString()}<br />
                        <span>Cancelling Date: </span>{moment(item.cancellingDate).startOf('day').toDate().toLocaleDateString()}<br />
                    </div>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>Redelivery</div>
                        <span>Redelivery Port: </span>{item.redeliveryPlaces[0] && item.redeliveryPlaces[0].port ? item.redeliveryPlaces[0].port.name : '---'}<br />
                    </div>
                </div>
                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>cargo</div>
                        <span>Cargo included: </span>{item.cargo.included[0] && item.cargo.included[0].cargo && item.cargo.included[0].cargo.name}<br />
                        <span>Cargo excluded: </span>{item.cargo.excluded[0] && item.cargo.excluded[0].cargo && item.cargo.excluded[0].cargo.name}
                    </div>

                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>Company</div>
                        <span>Name: </span>{item.context.company && item.context.company.name}
                    </div>

                    {
                        item.account &&
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Account</div>
                            <span>Name: </span>{ item.account.name }
                        </div>
                    }
                </div>
                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>User</div>
                        <span>Name: </span>{item.context.user.name}<br />
                        <span>Surname: </span>{item.context.user.surname}<br />
                    </div>
                    {
                        item.realUser && (
                            <div className='paper-block'>
                                <div className='name-block absolute small-name'>Real user</div>
                                <span>Email: </span>{item.realUser.email}<br />
                            </div>
                        )
                    }
                    {managementBlock}
                    {
                        item.mailId && <OpenMailBlock mailId={item.mailId} />
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {};
    },
    dispatch => bindActionCreators({
        deleteRequestTC,
    },
    dispatch),
)(TcRequestsItem);



// WEBPACK FOOTER //
// ./app/components/TimeCharter/Requests/Item.jsx